
    const config = {
      api_url: 'https://ccc.wangwanglive.com/apinew/',
      // api_url: 'https://ccc.wangwanglive.com/front/',
      login_url: 'https://www.flw.ph/plugin.php?id=zimu_fenlei&model=apiloginccc',
      SETTLEMENT: 3, 
      SOURCE: 3, // 默认来源标识，1为默认，2为h5.qqloon.com，3为h5.feilongvip.com
    };

    export default config;



// WEBPACK FOOTER //
// ./src/config/index.js